import OrganisationTypeEnum from '@constants/enums/organisation/type';

import CustodianApi from '@packages/custodians/api';

import { Organisation } from '@/models';

export class Custodian extends Organisation {
    static name = 'Custodian';
    static entity = 'custodians';
    static Api = CustodianApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.CUSTODIAN).nullable(),
            //
            default_listed: this.boolean(false).nullable(),
            default_unlisted: this.boolean(false).nullable(),
            //
            accounts: this.attr([]).nullable(),
            funds: this.attr([]).nullable(),
            vcts: this.attr([]).nullable(),
            offers: this.attr([]).nullable()
        };
    }
}

export default Custodian;
